// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"text_pageTitle__2s85Y","sectionTitle":"text_sectionTitle__2m2EC"};